import { render, staticRenderFns } from "./prestamoFilters.vue?vue&type=template&id=1b8a472d"
import script from "./prestamoFilters.vue?vue&type=script&lang=js"
export * from "./prestamoFilters.vue?vue&type=script&lang=js"
import style0 from "./prestamoFilters.vue?vue&type=style&index=0&id=1b8a472d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports